const SecretariaActionTypes = {
    SECRETARIA_SELECTED: 'secretaria/selected',
};

export default SecretariaActionTypes;